import LogRocket from 'logrocket';

const CONNECT_KEY = '7jvp4j/capusta';
const SECURE_URLS = [
  'protected/card',
  'protected/identification',
  'protected/self-employed',
];

const checkURL = url => SECURE_URLS.some(item => url.match(item));

const options = {
  network: {
    requestSanitizer: request => {
      const url = request.url.toLowerCase();

      if (request.headers.Authorization) {
        request.headers.Authorization = '';
      }

      if (checkURL(url)) {
        request.body = null;
      }

      return request;
    },
    responseSanitizer: response => {
      if (response.headers.Authorization) {
        // removes all response data
        return null;
      }

      // scrubs response body
      response.body = null;

      return response;
    },
  },
};

function init() {
  try {
    LogRocket.init(CONNECT_KEY, options);
  } catch (e) {
    console.error(e);
  }
}

function identify(data) {
  const userData = {
    id: data.id,
    name: data.name,
    status: data.status,
    theme: data.theme,
    selfEmployed: data.selfEmployed,
    twoFactorAuthTypeId: data.twoFactorAuthTypeId,
    needIdentification: data.needIdentification,
    botSigned: data.botSigned,
  };

  LogRocket.identify(data.id, userData);
}

function logger(error) {
  LogRocket.captureMessage(error);
}

export default {
  init,
  identify,
  logger,
};
